import React, { useEffect, useState } from 'react';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { Container } from 'react-bootstrap';
import { app } from '../../credenciales.js';
import FloatingBtn from '../../components/FloatingBtn/FloatingBtn.jsx';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 
import Calendar from '../../components/Calendar/Calendar.jsx';
import ActivityFormModal from '../../components/Modals/ActivityFormModal.jsx';

const HomeAdmin = () => {
  const db = getFirestore(app);
  const [activities, setActivities] = useState();
  const [showAddModal, setShowAddModal] = useState(false);
  
  useEffect(() => {
    const fetchActivities = async () => {
      const actividadesRef = collection(db, "actividades");
      const snapshot = await getDocs(actividadesRef);
      const allDates = [];
      const activitiesData = {};

      snapshot.forEach((doc) => {
        const data = doc.data();
        if (data.fechas) {
          data.fechas.forEach((fecha) => {
            if (!activitiesData[fecha.fecha]) {
              activitiesData[fecha.fecha] = [];
            }
            activitiesData[fecha.fecha].push({ id: doc.id, name: data.nombre, time: fecha.fecha, hora: data.hora, isSingleClass: data.isSingleClass });
          });
        }
      });

      //setActivityDates(allDates);
      setActivities(activitiesData);
    };

    fetchActivities();
  }, [activities]);

  const handleShowAddModal = () => {
    setShowAddModal(true);
  };

  const handleCloseAddModal = () => setShowAddModal(false);

  return (
    <Container className='py-4'>
      <h1 className='titles'>Calendario de Actividades</h1>
      
      <div className="calendar-wrapper">
      {activities && <Calendar activities={activities} isAdmin={true} />}
      </div>

      <FloatingBtn handleShowAddModal={handleShowAddModal} />
      <ActivityFormModal showModal={showAddModal} handleCloseModal={handleCloseAddModal} edit={false} />
    </Container>
  );
};

export default HomeAdmin;